export default "__VITE_ASSET__DQUn9IIO__"